<template>
  <div>
    <h1>Create an account</h1>
    <p><input type="text" placeholder="Email" v-model="email" /></p>
    <p><input type="password" placeholder="Password" v-model="password" /></p>
    <p>
      <input
        type="password"
        placeholder="Confirm password"
        v-model="passwordConfirmed"
      />
    </p>
    <div id="error-reason-sign-up">{{ errorReason }}</div>
    <p>
      <button id="register-button" class="button-large" @click="register">
        Submit
      </button>
    </p>
  </div>
</template>

<script>
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import store from "../store";

export default {
  data() {
    return {
      email: "",
      password: "",
      passwordConfirmed: "",
      errorReason: "",
    };
  },

  methods: {
    register() {
      if (
        this.email === "" ||
        this.password === "" ||
        this.passwordConfirmed === ""
      ) {
        console.log("either email, password, or confirmed password is null");
        return;
      }

      if (this.password !== this.passwordConfirmed) {
          this.showErrorReason('Passwords are not equal.')
          return;
      }

      const auth = getAuth();
      createUserWithEmailAndPassword(auth, this.email, this.password)
        .then((userCredential) => {
          store.commit("login", userCredential);
          let el = document.getElementById('sign-up')
          el.style.display = 'none'
        })
        .catch((error) => {
          if (error.message.includes('auth/weak-password')) {
            this.showErrorReason('Password should be at least 6 characters.')
            return;
          }

          if (error.message.includes('auth/email-already-in-use')) {
            this.showErrorReason('The provided email is already in use.')
            return;
          }

          if (error.message.includes('auth/invalid-email')) {
            this.showErrorReason('The provided value for the email user property is invalid. It must be a string email address.')
            return;
          }

          this.showErrorReason(error.message)
        });
    },

    showErrorReason(errorMessage) {
      this.errorReason = errorMessage;
      let el = document.getElementById("error-reason-sign-up");
      el.style.display = "block";
    }
  },
};
</script>

<style>
#register-button {
  background-color: hsl(174, 72%, 76%);
}

#register-button:hover {
  background-color: hsl(174, 72%, 56%);
}

#register-button:active {
  background-color: hsl(174, 72%, 46%);
}

#error-reason-sign-up {
  display: none;
  color: var(--warning-text-color);
  background-color: var(--warning-background-color);
  border-radius: 10px;
  padding: 2px 5px;
}
</style>